import * as $http from 'axios'

export default {
    datings: targetId => $http.get(`v2/datings${targetId ? `?target_id=${targetId}` : ''}`),
    success: () => $http.get('v2/datings/success'),
    checkDatingRequests: userId => $http.get(`v2/datings/check_dating_requests${userId ? `?user_id=${userId}` : ''}`),
    feedback: (datingId, payload) => $http.post(`v2/datings/${datingId}/feedbacks`, payload),
    reviewCandidate: () => $http.get('v2/datings/review_candidate'),
}
